import React from 'react'
import { useAuthenticator } from '@aws-amplify/ui-react';
import RequireAuth from '../components/auth/RequireAuth';


const Profile = () => {
    const { user, signOut } = useAuthenticator((context) => [context.user]);
    
    return (
        <RequireAuth allowedRoles={['FrgUsers']}>
            <div className='body'>
                <div>Profile</div>  
                <br />
                <button onClick={() => signOut()}>Sign Out</button>
            </div>
        </RequireAuth>
    )
}


export default Profile